module.exports = __webpack_public_path__ + "assets/img/00.28f29748.png";